
import React from 'react';
import { Button } from "@/components/ui/button";
import { RefreshCw, LogOut } from "lucide-react";
import { useStripeConnectionCheck } from '@/utils/stripeConnectionCheck';

interface StripeConnectionStatusProps {
  isConnected: boolean;
  accountId: string | null;
  isConnecting: boolean;
  onDisconnect: () => void;
}

const StripeConnectionStatus: React.FC<StripeConnectionStatusProps> = ({
  isConnected,
  accountId,
  isConnecting,
  onDisconnect
}) => {
  const { checkConnection } = useStripeConnectionCheck();

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h3 className="text-lg font-medium">Connection Status</h3>
        <div className="flex items-center space-x-2">
          <div className="h-3 w-3 rounded-full bg-green-500"></div>
          <span className="text-green-600 font-medium">Connected</span>
        </div>
        
        {accountId && (
          <p className="text-sm text-muted-foreground">
            Account ID: {accountId.substring(0, 8)}...{accountId.substring(accountId.length - 4)}
          </p>
        )}
      </div>
      
      <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
        {/* <Button 
          variant="outline" 
          size="sm" 
          className="w-full sm:w-auto"
          onClick={checkConnection}
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Verify Connection
        </Button> */}
        
        <Button 
          variant="destructive" 
          size="sm" 
          className="w-full sm:w-auto"
          onClick={onDisconnect}
          disabled={isConnecting}
        >
          <LogOut className="h-4 w-4 mr-2" />
          Disconnect
        </Button>
      </div>
    </div>
  );
};

export default StripeConnectionStatus;
